module.exports = __webpack_public_path__ + "img/camera_up_selected.6522db7b.svg";